import { components } from 'admin/schema/docs/api/admin';
import React from 'react';
import { RouteComponentProps, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { formatUUID } from '../../../utils';
import Grid from '../../atoms/Grid';
import Headings from '../../atoms/Headings';
import BreadCrumb from '../../molecules/BreadCrumb';
import Debts from './Debts';

type Customer = components['schemas']['Customer'];

const Table = styled(Grid.Container)`
  margin-top: 12px;
`;

const GridHeader = styled(Grid.Container)``;

const crumbs = (id?: string) => [
  { value: 'ホーム', href: '/', isCurrentPage: false },
  { value: 'お客様管理', href: '/customers', isCurrentPage: false },
  { value: `お客様詳細: ${formatUUID(id) || ''}`, href: `/customers/${id}`, isCurrentPage: false },
  { value: '負債情報', href: '', isCurrentPage: true },
];

const COLUMNS = ['ポイント金額', 'ポイント負担先店舗（組織名）', '発生日', '最終更新日'];

const CustomerDetailDebt = ({ match }: RouteComponentProps<{ id?: string }>) => {
  const customerId = match.params.id;
  const { state } = useLocation<{ customer: Customer }>();
  const accountUuid = state?.customer?.account_uuid;

  return (
    <>
      <BreadCrumb crumbs={crumbs(customerId)} />
      <Headings.h5>負債情報</Headings.h5>
      <Table gridSize={1}>
        <GridHeader>
          {COLUMNS.map((col) => (
            <Grid.Item key={col} size={3}>
              {col}
            </Grid.Item>
          ))}
        </GridHeader>
        <Grid.Divider margin="0" />
        <Debts accountId={accountUuid} />
      </Table>
    </>
  );
};

export default CustomerDetailDebt;
